import SBCBanner from "../images/SBCBanner.webp";
import MAP from "../images/floorplan.pdf";

export default function Floorplan() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100%",
      }}
    >
      <img
        src={SBCBanner}
        alt="Speaker list"
        style={{ width: "100%", flexShrink: 0 }}
      />

      <iframe
        src={MAP}
        title="Floorplan PDF"
        style={{
          flexGrow: 1,
          width: "100%",
          border: "none",
          minHeight: 0,
        }}
      />
    </div>
  );
}
